import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import color from 'color';
import Switch from 'react-switch';

import { getCssVariable } from 'uikit/utils';

import styles from '../styles/uikitInputsSwitchInput.module.scss';

const SwitchInput = ({
  className = '',
  height = 26,
  isChecked = false,
  isDisabled = false,
  isPositionStart = false,
  onChange = () => {},
  text = '',
  toggleId,
  width = 48,
}) => {
  const onColorVar = getCssVariable({ variableKey: '--ids-color-success' });
  const offColorVar = '#88898b'; // = --ids-color-background-primary-transparent60
  const onColor = !!onColorVar && color(onColorVar).hex();
  const offColor = !!offColorVar && color(offColorVar).hex();

  return (
    <div
      className={classnames(styles.element, {
        [styles.isDisabled]: isDisabled,
        [styles.isPositionStart]: isPositionStart,
      })}
    >
      {!isPositionStart && <span className={styles.text}>{text}</span>}
      <Switch
        role="switch"
        aria-checked={isChecked}
        id={toggleId}
        className={classnames(styles.toggle, className)}
        checked={isChecked}
        onChange={(checked) => onChange(checked)}
        disabled={isDisabled}
        onColor={onColor}
        offColor={offColor}
        height={height}
        width={width}
        handleDiameter={18}
        boxShadow={styles.boxShadow}
        activeBoxShadow={styles.activeBoxShadow}
        uncheckedIcon={false}
        checkedIcon={false}
      />
      {isPositionStart && <span className={styles.text}>{text}</span>}
    </div>
  );
};

SwitchInput.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isPositionStart: PropTypes.bool,
  onChange: PropTypes.func,
  text: PropTypes.string,
  toggleId: PropTypes.string.isRequired,
  width: PropTypes.number,
};

export { SwitchInput as SwitchInputStorybook };
export default React.memo(SwitchInput);
